import { render, staticRenderFns } from "./TheMenu.vue?vue&type=template&id=4f92aa42"
import script from "./TheMenu.vue?vue&type=script&lang=js"
export * from "./TheMenu.vue?vue&type=script&lang=js"
import style0 from "./TheMenu.vue?vue&type=style&index=0&id=4f92aa42&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports